import styled from 'styled-components';

export const ListingPageContent = styled.div`
  // UI mobile and mobile base
  @media only screen and (max-width: 599px) {
    p {
      margin-top: 0;
    }
    overflow: hidden;
  }

  clear: both;
  transform: none;

  // Tablet and touch base
  @media only screen and (max-width: 1024px) {
    position: relative;
    clear: both;
    padding: 10px 10px 0;
    z-index: 1;
    background: #fff;
    border-bottom: 1px solid #ccc;
    box-shadow: -1px 0 1em rgba(black, 0.3);
    transform: translate3d(0, 0, 0);
    -webkit-backface-visibility: hidden;
    backface-visibility: hidden;

    box-sizing: border-box;

    > .breadcrumb {
      margin-bottom: 10px;
    }

    padding-left: 10px;
    padding-right: 10px;
  }

  // Desktop base
  @media only screen and (min-width: 1025px) {
    position: relative;
    z-index: 2;

    > .breadcrumb {
      position: relative;
      top: -1px;
      margin-bottom: 10px;
    }
  }
`;

export const AsideFilters = styled.aside`
  @media only screen and (max-width: 599px) {
    height: 4px;
    width: 1px;
    margin: 0;
  }
  @media only screen and (max-width: 1024px) {
    height: 4px;
    width: 1px;
    margin: 0;
  }
`;

export const ListingPageOverlay = styled.div`
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background: white;
  opacity: 0.85;
  pointer-events: none;
  cursor: pointer;
  z-index: 10000;
`;

export const ListPageFilterButton = styled.div`
  @media only screen and (min-width: 1025px) {
    display: none;
  }
`;

export const FilterResultsMessageContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;

  @media only screen and (max-width: 1024px) {
    padding-bottom: 15px;
    border-bottom: 2px solid #f2f2f2;
  }

  .dc-tooltip {
    display: inline-block;
    color: #ed8812;
    font-size: 13px;
    padding: 10px;
    border: 0;
    margin-bottom: 0;
    margin-right: 5px;
  }
`;

export const SortForm = styled.div`
  position: relative;
  margin-bottom: 23px;
  margin-top: 10px;

  @media only screen and (min-width: 600px) {
    margin-bottom: 0;
  }
`;

export const SortByWrapper = styled.div`
  @media only screen and (max-width: 599px) {
    margin-bottom: 23px;
    width: 100%;
  }
  @media only screen and (min-width: 600px) {
    width: 250px;
  }


  .dc-sort-by {
    @media ${(p) => p.theme.breakpoints.mobileMin} {
      .dc-sort-by-label {
        display: inline-block;
      }
    }

    .dc-select-list-item {
      overflow: hidden;
    }
  }

  .dc-select-list-item:not(:first-child):before {
    content: '';
    position: absolute;
    left: 10px;
    top: 0;
    height: 1px;
    width: calc(100% - 20px);
    background-color: #ccc;
  }

  .dc-sort-by .dc-select-list-item {
    position: relative;
    border: 0;
  }
`;

export const ItemsPerPage = styled.div`
  margin-left: 0;

  @media only screen and (min-width: 600px) {
    position: absolute;
    top: 13px;
    left: 50%;
    margin-left: -59px;

    @media screen and (min-width: 600px) and (max-width: 768px) {
      margin-left: -33px;
    }
  }
`;
